(() => {
  const DEFAULT_PLACE_ID = '39429996683';
  const CHANGE_STORE_SELECTOR =
    '.rcc-search__facet--rccLocalInventory .rcc-search__facet__clear, .rcc-search__facet--rccLocalInventory .rcc-search__quick-filters__dropdown-clear-button, [data-rcc-change-store]';
  const PLACE_ID_CHANGED_EVENT = 'rcc-search:place-id-changed';
  const getPlaceId = () =>
    window.Nimstrata.placeId ||
    document.cookie.match(/(?:^|; )rcc-place-id=([^;]*)/)?.[1];
  let selectedPlaceId = getPlaceId() || DEFAULT_PLACE_ID;

  // The search app provides setPlaceId on collection and search pages. On product pages (no search app), write the
  // same cookie and fire the same event ourselves, so the choice carries over to the collection pages
  const setPlaceId = (placeId) => {
    if (typeof window.Nimstrata.setPlaceId === 'function') {
      window.Nimstrata.setPlaceId(placeId);
      return;
    }

    document.cookie = `rcc-place-id=${encodeURIComponent(placeId)}; path=/; max-age=31536000; SameSite=Lax`;
    selectedPlaceId = placeId;
    document.dispatchEvent(new Event(PLACE_ID_CHANGED_EVENT));
  };

  document.addEventListener(PLACE_ID_CHANGED_EVENT, () => {
    const placeId = getPlaceId();

    if (placeId) selectedPlaceId = placeId;
    else setPlaceId(selectedPlaceId);
  });

  const initializePlaceId = () => {
    selectedPlaceId = getPlaceId() || DEFAULT_PLACE_ID;
    window.Nimstrata.setPlaceId(selectedPlaceId);
  };

  if (typeof window.Nimstrata.setPlaceId === 'function') initializePlaceId();
  else
    window.addEventListener('rcc-search-store:registered', initializePlaceId, {
      once: true,
    });

  const dialog = document.createElement('dialog');
  dialog.className = 'nimstrata-store-picker';
  dialog.setAttribute('aria-labelledby', 'nimstrata-store-picker-title');
  dialog.setAttribute('aria-describedby', 'nimstrata-store-picker-description');
  dialog.innerHTML = `
    <header class="nimstrata-store-picker__header">
      <div>
        <h2 id="nimstrata-store-picker-title">Retail Locations</h2>
        <p id="nimstrata-store-picker-description">Prefer to pick up your order? Select the location you want to shop from.</p>
      </div>
      <button type="button" class="nimstrata-store-picker__close" data-store-picker-close aria-label="Close store picker">&times;</button>
    </header>
    <div class="nimstrata-store-picker__locations">
      <button type="button" class="nimstrata-store-picker__location" data-place-id="39429996683">
        <img src="/cdn/shop/files/Footprint.jpg?v=1782478149&amp;width=700" alt="Footprint USA Flagship Store" width="700" height="490" loading="lazy" decoding="async">
        <span class="nimstrata-store-picker__location-details">
          <strong>Footprint USA Flagship Store</strong>
          <span>1701 Taraval St<br>San Francisco CA 94116<br>+1(415) 664-4353</span>
          <small data-current hidden>Current store</small>
        </span>
      </button>
      <button type="button" class="nimstrata-store-picker__location" data-place-id="67139764363">
        <img src="/cdn/shop/files/FirstStep_FootPrint_Colma_Blvd.png?v=1782373737&amp;width=700" alt="First Step by Footprint" width="700" height="490" loading="lazy" decoding="async">
        <span class="nimstrata-store-picker__location-details">
          <strong>First Step by Footprint</strong>
          <span>9 Colma Blvd<br>Colma, CA 94014<br>Located at 280 Metro<br>+1(650) 991-2330</span>
          <small data-current hidden>Current store</small>
        </span>
      </button>
    </div>
  `;
  document.body.append(dialog);

  const openStorePicker = () => {
    const placeId = getPlaceId() || selectedPlaceId;
    const locations = dialog.querySelectorAll('[data-place-id]');

    locations.forEach((location) => {
      const isCurrent = location.dataset.placeId === placeId;
      location.setAttribute('aria-pressed', String(isCurrent));
      location.querySelector('[data-current]').hidden = !isCurrent;
    });

    if (!dialog.open) dialog.showModal();
    (dialog.querySelector('[aria-pressed="true"]') || locations[0]).focus();
  };

  document.addEventListener(
    'click',
    (event) => {
      if (
        event.target instanceof Element &&
        event.target.closest(CHANGE_STORE_SELECTOR)
      ) {
        queueMicrotask(openStorePicker);
      }
    },
    true,
  );

  dialog.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const location = event.target.closest('[data-place-id]');
    if (location) {
      setPlaceId(location.dataset.placeId);
      dialog.close();
    } else if (
      event.target === dialog ||
      event.target.closest('[data-store-picker-close]')
    ) {
      dialog.close();
    }
  });
})();